import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-hot-toast";
import Pagination from "../../components/pagination";

import Loader from "../../components/loader";
import Modal from "../../components/modal";

import api from "../../services/api";

export default () => {
  const [filter, setFilter] = useState({ search: "", per_page: 50, page: 1 });

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row gap-5 items-center justify-between mb-10">
        <h3 className="text-xl font-bold shrink-0">Codes</h3>
        <div className="flex items-center justify-end gap-x-2.5">
          <div className="w-1/2 relative">
            <input
              className="input"
              type="search"
              placeholder="Type here..."
              value={filter.search}
              onChange={(e) => {
                e.persist();
                setFilter((prev) => ({
                  ...prev,
                  search: e.target.value,
                  page: 1,
                }));
              }}
            />
          </div>
          <Create />
        </div>
      </div>

      <Codes filter={filter} setFilter={setFilter} />
    </div>
  );
};

const Codes = ({ filter, setFilter }) => {
  const [codes, setCodes] = useState(null);
  const [total, setTotal] = useState(0);
  const history = useHistory();

  useEffect(() => {
    console.log("filter", filter);
    getCodes();
  }, [filter]);

  async function getCodes() {
    const { data } = await api.post("/codes/search", filter);
    setCodes(data.codes);
    setTotal(data.total);
  }

  if (!codes) return <Loader />;
  return (
    <>
      <div>
        <span className="text-sm font-normal text-gray-500">
          <>
            <span className="text-base font-medium text-gray-700">
              {codes?.length}
            </span>{" "}
            of {total}
          </>
        </span>
      </div>
      <div className="flow-root">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden ring-1 ring-primary-black-50">
              <table className="min-w-full divide-y divide-primary-black-50">
                <thead className="bg-white">
                  <tr>
                    <th
                      scope="col"
                      className="p-3 text-left text-h3-semibold text-primary-black-100"
                    >
                      Code
                    </th>
                    <th
                      scope="col"
                      className="p-3 text-left text-h3-semibold text-primary-black-100"
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      className="p-3 text-left text-h3-semibold text-primary-black-100"
                    >
                      Ending date
                    </th>
                    <th
                      scope="col"
                      className="p-3 text-left text-h3-semibold text-primary-black-100"
                    >
                      Match
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-primary-black-50 bg-white">
                  {codes.map((e) => (
                    <tr
                      key={e.id}
                      className={`odd:bg-[#FCFCFC] hover:bg-black-10 cursor-pointer`}
                      onClick={() => history.push(`/code/${e.id}`)}
                    >
                      <td className="whitespace-nowrap p-3 text-sm text-primary-black-90">
                        {e.code}
                      </td>
                      <td className="whitespace-nowrap p-3 text-sm text-primary-black-90">
                        {e.description}
                      </td>
                      <td className="whitespace-nowrap p-3 text-sm text-primary-black-90">
                        {(e.endingdate || "")?.slice(0, 10)}
                      </td>
                      <td className="whitespace-nowrap p-3 text-sm text-primary-black-90">
                        {e.match}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        per_page={filter.per_page}
        total={total}
        onNext={() => setFilter((f) => ({ ...f, page: +f.page + 1 }))}
        onPrevious={() => setFilter((f) => ({ ...f, page: +f.page - 1 }))}
        currentPage={filter.page}
      />
    </>
  );
};

const Create = () => {
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({ discount: 0, match: ".*" });
  const history = useHistory();

  async function onCreate() {
    const res = await api.post("/codes", values);
    if (!res.ok) return toast.error(res.error);
    toast.success("Created!");
    history.push(`/code/${res.data.id}`);
  }

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setOpen(true)}>
        Create code
      </button>

      <Modal
        isOpen={open}
        className="max-w-xl w-full p-6"
        onClose={() => setOpen(false)}
      >
        <div className="grid grid-cols-2 gap-4 mb-6">
          <div className="w-full">
            <div className="text-sm font-medium mb-2">Code</div>
            <input
              className="input block"
              value={values.code}
              onChange={(e) => setValues({ ...values, code: e.target.value })}
            />
          </div>
          <div className="w-full">
            <div className="text-sm font-medium mb-2">Description</div>
            <input
              className="input block"
              value={values.description}
              onChange={(e) =>
                setValues({ ...values, description: e.target.value })
              }
            />
          </div>
          <div className="w-full">
            <div className="text-sm font-medium mb-2">Ending date</div>
            <input
              className="input block"
              type="date"
              value={values.endingdate}
              onChange={(e) =>
                setValues({ ...values, endingdate: e.target.value })
              }
            />
          </div>
        </div>

        <button
          className="btn btn-primary mt-4 disabled:opacity-80 disabled:cursor-not-allowed"
          disabled={!values.code || !values.description || !values.endingdate}
          onClick={onCreate}
        >
          Create
        </button>
      </Modal>
    </div>
  );
};
